"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FadeTransition = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var transition_1 = require("../_util/transition");
var BaseTransition_1 = require("./BaseTransition");
function FadeTransition(_a) {
    var opacity = _a.opacity, timeout = _a.timeout, rest = tslib_1.__rest(_a, ["opacity", "timeout"]);
    var enterTimeout;
    var exitTimeout;
    if (typeof timeout === "number") {
        enterTimeout = timeout;
        exitTimeout = timeout;
    }
    else if (timeout && typeof timeout === "object") {
        enterTimeout = timeout.enter;
        exitTimeout = timeout.exit;
    }
    return (react_1.default.createElement(BaseTransition_1.BaseTransition, tslib_1.__assign({}, transition_1.fade(opacity, enterTimeout, exitTimeout), rest)));
}
exports.FadeTransition = FadeTransition;
FadeTransition.displayName = "FadeTransition";
//# sourceMappingURL=FadeTransition.js.map